/**
 * Joins a list in the active locale's own conjunction style. `Intl.ListFormat` replaces a
 * hand-rolled Oxford comma, which is correct only in English; it is native in every targeted
 * browser and under Node's full-ICU build, so there is no polyfill. Falls back to a plain comma
 * join rather than blanking the clause. Shared so every list the UI renders agrees on the separator.
 */
export function joinList(locale: string, items: readonly string[]): string {
  if (items.length <= 1) {
    return items[0] ?? '';
  }
  try {
    return new Intl.ListFormat(locale, {
      style: 'long',
      type: 'conjunction',
    }).format(items);
  } catch {
    return items.join(', ');
  }
}
